import React from "react"
import { ImageFilter } from "~/data/imageFilters"

interface Props {
  filter?: ImageFilter
  filterId: string
}

const SvgColorMatrixFilter: React.FC<Props> = ({ filter, filterId }) => {
  if (!filter || filter.name === "original") {
    return null
  }

  return (
    <defs>
      <filter id={filterId} colorInterpolationFilters="sRGB">
        <feColorMatrix type="matrix" values={filter.matrix} />
      </filter>
    </defs>
  )
}

export default SvgColorMatrixFilter
